import {RouteEntry} from "../../shared/routes";
import {Login} from "./Login";

export const accountRoutes: Array<RouteEntry> = [
    { path: '/account/login', component: Login },
];
